import React from "react"
import PropTypes from "prop-types"
import { Spacer } from "@bw/bits"
import * as Icons from "@bw/icons"
import styled from "styled-components"

const StyledSocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  gap: ${props => props.$gap};
  background: transparent;
  font-size: 12px;
  font-weight: 400;
  line-height: 135.5%;
  color: #04062c;
  opacity: 1;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
    text-decoration: underline;
    opacity: 0.5;
    > * {
      fill: ${props =>
        props.fillColorFacebook
          ? "blue"
          : props.fillColorInsta
          ? "blue"
          : "black"};
    }
  }
`

const Socials = ({
  fillColorFacebook,
  fillColorInsta,
  fillColorLinkedin,
  fillColorDiscord,
  gap,
}) => {
  return (
    <Spacer direction="row" gap="medium">
      <StyledSocialLink
        to="https://www.facebook.com/"
        target="_blank"
        rel="noreferrer"
        $gap={gap}
        className="facebook"
      >
        <Icons.Facebook fillColor={fillColorFacebook} />
      </StyledSocialLink>
      <StyledSocialLink
        to="https://www.instagram.com/"
        target="_blank"
        rel="noreferrer"
        $gap={gap}
        className="instagram"
      >
        <Icons.Instagram fillColor={fillColorInsta} />
      </StyledSocialLink>
      <StyledSocialLink
        to="https://www.linkedin.com/"
        target="_blank"
        rel="noreferrer"
        $gap={gap}
        className="linkedin"
      >
        <Icons.Linkedin fillColor={fillColorLinkedin} />
      </StyledSocialLink>
      <StyledSocialLink
        to="https://www.behance.net/"
        target="_blank"
        rel="noreferrer"
        $gap={gap}
        className="discord"
      >
        <Icons.Discord fillColor={fillColorDiscord} />
      </StyledSocialLink>
    </Spacer>
  )
}

export { Socials }

Socials.propTypes = {
  fillColorFacebook: PropTypes.string,
  fillColorInsta: PropTypes.string,
  fillColorLinkedin: PropTypes.string,
  fillColorDiscord: PropTypes.string,
  displayNames: PropTypes.bool,
  gap: PropTypes.string,
}

Socials.defaultProps = {
  fillColorFacebook: "var(--primary)",
  fillColorInsta: "var(--primary)",
  fillColorLinkedin: "var(--primary)",
  fillColorDiscord: "var(--primary)",
  displayNames: false,
  gap: "25px",
}
